import { useGetResponsibleGamingLimitsQuery } from "@api/accountManagement";

const useController = () => {
	const limitsQuery = useGetResponsibleGamingLimitsQuery();

	return {
		state: {
			limits: limitsQuery.data?.limits || [],
			currency: limitsQuery.data?.currency,
			isLoading: limitsQuery.isLoading,
			isError: limitsQuery.isError,
		},
		handlers: {
			refetch: limitsQuery.refetch,
		},
	};
};

export default useController;
